import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const CircularProgress = ({ percentage }) => {
  const validPercentage = typeof percentage === "number" ? Math.min(100, Math.max(0, percentage)) : 0;
  
  // Dynamic color based on percentage (emerald green like reference screenshot)
  const pathColor = validPercentage > 50 ? "#10b981" : validPercentage > 20 ? "#ea580c" : "#f59e0b";

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <CircularProgressbar
        value={validPercentage}
        text={`${validPercentage}%`}
        styles={buildStyles({
          textSize: "24px",
          fontWeight: "800",
          textColor: "#0f172a",
          pathColor: pathColor,
          trailColor: "#e2e8f0",
          strokeLinecap: "round",
          pathTransitionDuration: 0.5,
        })}
      />
    </div>
  );
};

export default CircularProgress;